import React from 'react';
import { Typography, Button } from '@common-ui/ui';
import { Download } from '@mui/icons-material';
import { DownloadBaselineUploaderEnum } from '../../../enums/DownloadBaselineUploaderEnum';
import { getLatestUploader } from '../../../apis/visorAPI';

export default function DownloadBaselineUploaderDialog() {
  /**
   * Display a dialog to download the Baseline Uploader
   *
   *  @param {None} None
   *  @returns {JSX.Element}
   */

  const onClick = async () => {
    const { url } = await getLatestUploader();
    location.href = url;
  };

  return (
    <div style={container}>
      <div style={content}>
        <div style={group}>
          <div style={icon}>
            <img src="/B_tab_logo.png" width="68" height="68" />
          </div>
          <div style={text}>
            <Typography variant="h6" color="white">
              {DownloadBaselineUploaderEnum.TITLE}
            </Typography>
            <Typography sx={body}>{DownloadBaselineUploaderEnum.BODY}</Typography>
          </div>
        </div>
        <Button startIcon={<Download />} onClick={onClick} sx={button}>
          {DownloadBaselineUploaderEnum.UPLOAD_BUTTON}
        </Button>
      </div>
    </div>
  );
}

const accent = '#2B7CD3';
const bgColor = '#212121';

const container = {
  display: 'flex',
  background: bgColor,
  justifyContent: 'space-between',
  padding: '1em',
  margin: '20px 40px',
};

const content = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '1em',
  color: 'white',
  gap: '2em',
  flexGrow: 1,
};

const group = {
  display: 'flex',
  flexDirection: 'row',
  gap: '1em',
};

const icon = {
  borderRadius: '15px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const text = {
  color: 'white',
  gap: '15px',
};

const body = {
  color: '#9e9e9e',
};

const button = {
  color: 'white',
  backgroundColor: accent,
  borderRadius: '5px',
  padding: '10px 20px',
  '&:hover': { color: 'white' },
};
